module.exports = __webpack_public_path__ + "img/astronomers_3.d95a7501.jpg";